import { ArchiveState, TOGGLE_ARCHIVE_PENDING, SET_ARCHIVE_QUEUE, ArchiveActions,  } from "../types";


const initialState: ArchiveState = {
  pending: false,
  queue: []
}

export default function archiveReducer(state = initialState, action: ArchiveActions): ArchiveState {
  switch (action.type) {
    case TOGGLE_ARCHIVE_PENDING:
      return {
        ...state,
        pending: action.pending
      }
    case SET_ARCHIVE_QUEUE:
      return {
        ...state,
        queue: action.queue
      }
    default:
      return state
  }
}